import { RouteLocationNormalized, RouteRecordRaw } from 'vue-router';

import { ROUTER_PATHS } from './paths';

import { URL_CONSTANTS } from '@/constants';
import { EVENTS, mParticleMetric } from '@/metrics';

export const routes: RouteRecordRaw[] = [
	{
		path: ROUTER_PATHS.DESKTOP_DOWNLOAD,
		name: 'Download-Success',
		component: () =>
			import('@/views/DownloadSuccessView/DownloadSuccessView.vue'),
		meta: { title: 'Download Success', showProfileLink: true },
	},
	{
		path: ROUTER_PATHS.LOGIN_EMAIL_CODE_VALIDATION,
		name: 'Email-Code-View',
		component: () => import('@/views/EmailCodeView/EmailCodeView.vue'),
		meta: { title: 'Validate email code' },
	},
	{
		path: ROUTER_PATHS.LOGIN_SUCCESS_V2,
		name: 'Login-Successful-Activated',
		component: () => import('@/views/LoginSuccessView/LoginSuccessView.vue'),
		meta: {
			title: 'Activation success',
			showProfileLink: true,
		},
	},
	{
		// Platform redirects here when coming from successful xsolla login
		path: ROUTER_PATHS.ACCOUNT_WINDOWS_LOGIN_SUCCESSFUL,
		name: 'Account-Windows-Login-Successful',
		component: () => import('@/views/CrossRoadsView/CrossRoadsView.vue'),
		meta: { title: 'Activation success' },
	},
	{
		path: ROUTER_PATHS.ACCOUNT_ERROR,
		name: 'Activation-Error',
		component: () =>
			import('@/views/ActivationExpiredView/ActivationExpiredView.vue'),
		meta: { title: 'Activation error' },
	},
	{
		path: ROUTER_PATHS.LOGIN,
		name: 'Account-Home-View',
		component: () => import('@/views/AccountHomeView/AccountHomeView.vue'),
		meta: { title: 'Voicemod Account' },
	},
	{
		path: ROUTER_PATHS.CHECKOUT_V2,
		name: 'Checkout',
		component: () => import('@/views/CheckoutView/CheckoutView.vue'),
		meta: { title: 'Voicemod Checkout', requiresXsolla: true },
	},
	{
		path: ROUTER_PATHS.CHECKOUT_V3,
		name: 'Flagship-Checkout',
		component: () =>
			import('@/views/FlagshipCheckoutView/FlagshipCheckoutView.vue'),
		meta: { title: 'Voicemod Checkout', requiresXsolla: true },
	},
	{
		path: ROUTER_PATHS.CHECKOUT_PAYMENT_CHECK,
		name: 'Payment-Check',
		component: () => import('@/views/PaymentCheckView/PaymentCheckView.vue'),
		meta: { title: 'Voicemod Payment check', requiresXsolla: true },
	},
	{
		path: ROUTER_PATHS.CHECKOUT_PAYMENT_SUCCESS,
		name: 'Payment-Success',
		component: () =>
			import('@/views/PaymentSuccessView/PaymentSuccessView.vue'),
		meta: { title: 'Voicemod payment success', requiresXsolla: true },
	},
	{
		path: ROUTER_PATHS.CHECKOUT_PAYMENT_ERROR,
		name: 'Payment-Error',
		component: () => import('@/views/PaymentErrorView/PaymentErrorView.vue'),
		meta: { title: 'Voicemod payment error', requiresXsolla: true },
	},
	{
		path: ROUTER_PATHS.ACCOUNT,
		name: 'User-Account',
		component: () => import('@/views/UserAccountView/UserAccountView.vue'),
		meta: { title: 'Voicemod User Account' },
	},
	{
		path: ROUTER_PATHS.CROSSROADS,
		name: 'Cross-Roads',
		component: () => import('@/views/CrossRoadsView/CrossRoadsView.vue'),
		meta: { title: 'Redirecting' },
	},
	{
		path: ROUTER_PATHS.VOICEMOD_CONTROLLER_APP,
		name: 'Voicemod-Controller-App',
		component: () => import('@/views/ControllerAppView/ControllerAppView.vue'),
		meta: { title: 'Voicemod Controller App' },
	},
	{
		path: ROUTER_PATHS.VOICEMOD_SOUNDBOARD_APP,
		name: 'Voicemod-Soundboard-App',
		component: () => import('@/views/SoundboardAppView/SoundboardAppView.vue'),
		meta: { title: 'Voicemod Soundboard App' },
	},
	{
		path: ROUTER_PATHS.LOGIN_SUCCESS_V3,
		name: 'Flagship-login-success',
		component: () =>
			import('@/views/FlagshipLoginSuccessView/FlagshipLoginSuccessView.vue'),
		meta: { title: 'Activation success', showProfileLink: true },
	},
	{
		path: ROUTER_PATHS.LOGIN_SUCCESS_STORE,
		name: 'Store',
		component: () => import('@/views/StoreView/StoreView.vue'),
		meta: { title: 'Store' },
	},
	{
		path: ROUTER_PATHS.LOGIN_SUCCESS_TUNA,
		name: 'Tuna-login-success',
		component: () =>
			import('@/views/TunaLoginSuccessView/TunaLoginSuccessView.vue'),
		meta: { title: 'Tuna login success' },
	},
	{
		path: ROUTER_PATHS.LOGIN_SUCCESS_MOBILE,
		name: 'VM-soundboard-login-success',
		component: () =>
			import(
				'@/views/VMSoundboardLoginSuccessView/VMSoundboardLoginSuccessView.vue'
			),
		meta: { title: 'VM Soundboard login success', showProfileLink: true },
	},
	{
		path: ROUTER_PATHS.REDIRECT_COUPON,
		name: 'Coupon-login-success',
		component: () =>
			import('@/views/CouponLoginSuccessView/CouponLoginSuccessView.vue'),
		meta: { title: 'Redeem a coupon login success' },
	},
	{
		path: ROUTER_PATHS.CHECKOUT_PADDLE_PAYMENT_CHECK,
		name: 'Paddle-payment-check',
		component: () =>
			import('@/views/PaddlePaymentCheckView/PaddlePaymentCheckView.vue'),
		meta: { title: 'Paddle Payment Check' },
	},
	{
		path: ROUTER_PATHS.ACCOUNT_DELETED,
		name: 'Deleted-account',
		component: () =>
			import('@/views/DeletedAccountView/DeletedAccountView.vue'),
		meta: { title: 'Account Deleted' },
	},
	{
		path: ROUTER_PATHS.MOBILE_DOWNLOAD_REDIRECT,
		name: 'Redirect-mobile-download',
		component: () =>
			import('@/views/RedirectMobileDownload/RedirectMobileDownload.vue'),
		meta: { title: 'Redirect Mobile Download' },
	},
	{
		path: ROUTER_PATHS.REDIRECT_REPORT_MODERATOR,
		name: 'Report-moderator-login-success',
		component: () =>
			import(
				'@/views/ReportModeratorLoginSuccessView/ReportModeratorLoginSuccessView.vue'
			),
		meta: { title: 'Report Moderator login success' },
	},
	{
		path: ROUTER_PATHS.LOGIN_SUCCESS_TWITCH,
		name: 'Twitch-Success-Connection',
		component: () =>
			import(
				'@/views/TwitchSuccessConnectionView/TwitchSuccessConnectionView.vue'
			),
		meta: { title: 'Twitch Connection Success' },
	},
	{
		path: ROUTER_PATHS.AUTHORIZE,
		name: 'Authorize-Client-View',
		component: () =>
			import('@/views/AuthorizeClientView/AuthorizeClientView.vue'),
		meta: { title: 'Voicemod Authorize Client' },
	},
	{
		path: ROUTER_PATHS.CONNECT_SUCCESS,
		name: 'Connect-Success',
		component: () => import('@/views/ConnectSuccess/ConnectSuccess.vue'),
		meta: { title: 'Connect Success' },
	},
	{
		path: ROUTER_PATHS.CONNECT_ERROR,
		name: 'Connect-Error',
		component: () => import('@/views/ConnectError/ConnectError.vue'),
		meta: { title: 'Connect Error' },
	},
	{
		path: '/gone',
		name: '410-gone',
		component: () => import('@/views/Error404View/Error404View.vue'),
		alias: [
			ROUTER_PATHS.BEG,
			ROUTER_PATHS.BEG_GIFTING,
			ROUTER_PATHS.GIFT,
			ROUTER_PATHS.GIFT_SUCCESS,
			ROUTER_PATHS.VM_KEY_COMPLETE_ORDER,
			ROUTER_PATHS.VM_KEY_ORDER_SUCCESS,
			ROUTER_PATHS.VM_KEY,
			ROUTER_PATHS.ADDRESS_FORM,
			ROUTER_PATHS.BROADCAST,
			ROUTER_PATHS.VOICEROOM,
			ROUTER_PATHS.SHARE_SUCCESS,
			ROUTER_PATHS.TTSING,
			ROUTER_PATHS.VMGO,
			ROUTER_PATHS.BETA_PROGRAM_ACCEPTED,
			ROUTER_PATHS.AI_BETA_PROGRAM_ACCEPTED,
		],
		beforeEnter: async (to: RouteLocationNormalized): Promise<void> => {
			await mParticleMetric.track(EVENTS.LEGACY_ROUTE_REDIRECTED, {
				action: to.query.action,
				path: to.path,
			});
			mParticleMetric.sendPendingEvents();

			window.location.href = URL_CONSTANTS.HOMEPAGE;
		},
	},
	{
		path: '/:pathMatch(.*)*',
		name: 'Error-404',
		component: () => import('@/views/Error404View/Error404View.vue'),
		meta: { title: 'Page not found' },
	},
];
